<template>
  <div class="margin-top-20">
    <div class="pre-class-school-list__filter__action">
      <div class="row">
        <div class="col-md-3 item item__key input-custom-icon">
          <input v-model="paramQueryData.keyword" v-debounce="300" type="text" placeholder="Tìm kiếm bài tập, đề thi"
            class="primary-color-txt color_bg_gray_light border-rd-20 font-size-15 form-h30 border-0 full-width filter-keyword" />
          <i class="icon-search font-size-16 primary-color"></i>
        </div>
        <div class="col-md-3">
          <b-form-select @change="handleChangeClassId" v-model="paramQueryData.classId" :options="listDataClass">
            <!-- <option value=0>Khối - Tất cả</option> -->
          </b-form-select>
        </div>

        <div class="col-md-3">
          <b-form-select @change="handleChangeSubjectId" v-model="paramQueryData.subjectId" :options="listDataSubject">
            <!-- <option value=0>Môn học - Tất cả</option> -->
          </b-form-select>
        </div>

        <div class="col-md-3">
          <b-form-select v-model="paramQueryData.typeExamId" :options="listTypeExcercise">

          </b-form-select>
        </div>
      </div>
    </div>
    <div v-if="listDataExam.length > 0" class="data-body margin-top-20">
      <div class="row">
        <div class="col-md-8 text-center header-title">Tên đề</div>
      </div>
      <div class="row margin-top-10" v-for="(item, index) of listDataExam" :key="index">
        <div class="col-md-8">
          {{ item.name }}
        </div>
        <div class="col-md-4">
          <div class="row">
            <div class="col-md-6">
              <a href="javascript:;" @click="handleViewExam(item)"
                class="item btn border-rd-20 font-size-16 display-flex-center item__add justify-content-center">
                Xem trước
              </a>
            </div>
            <div class="col-md-6">
              <a href="javascript:;" @click="handleAssignExam(item)"
                class="item btn btn-main border-rd-20 font-size-16 display-flex-center justify-content-center item__add">
                Giao bài
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="data-body margin-top-20" style="text-align: center">
      Ngân hàng đề không có dữ liệu
    </div>
    <div class="row pagination container m-0">
      <b-pagination pills v-model="paramQueryData.pageIndex" :total-rows="totalRecords"
        :per-page="paramQueryData.pageSize" first-number last-number></b-pagination>
    </div>
    <ModalAssignExcercise :item="itemExamSelected" :type="3" v-if="isOpenModalAssignExam"
      @closeModal="handleCloseModalAssignExam" />
    <ModalViewExam @closeModal="handleCloseModalViewExam" :lessonClassSchoolId="lessonClassSchoolId"
      v-if="isOpenModalViewExam" />
  </div>
</template>
<script>
import { getAllTypeFilter, getAllClassFilter } from "./../../_api/";
import { getListBankExamExcercise } from "./../../_api/LessonClassSchoolServices";
import ModalAssignExcercise from "./_components/ModalAssignExcercise";
import debounce from "@/directives/debounce";
import ModalViewExam from './../../_components/ModalViewExam'
export default {
  directives: { debounce },
  components: {
    ModalAssignExcercise,
    ModalViewExam
  },
  data() {
    return {
      isOpenModalViewExam: false,
      isOpenModalAssignExam: false,
      itemExamSelected: null,
      paramQueryData: {
        keyword: "",
        pageIndex: 1,
        pageSize: 10,
        subjectId: 0,
        classId: 0,
        typeExamId: 0
      },
      listTypeExcercise: [
        { text: 'Loại đề - Tất cả', value: 0 },
        { text: 'Đề 15 phút', value: 1 },
        { text: 'Đề 45 phút', value: 2 },
        { text: 'Đề thi học kỳ', value: 3 },],
      listDataClass: [{ value: 0, text: "Khối - Tất cả" }],
      listDataSubject: [{ value: 0, text: "Môn học - Tất cả" }],
      listDataExam: [],
      totalRecords: 0,
      lessonClassSchoolId: ''
    };
  },
  watch: {
    "paramQueryData.classId": "handleChangeClassId",
    "paramQueryData.keyword": "getDataExam",
    "paramQueryData.subjectId": "handleChangeSubjectId",
    "paramQueryData.pageIndex": "getDataExam",
    "paramQueryData.typeExamId": "getDataExam",
  },
  mounted() {
    this.GetAllClass();
    this.getDataExam();
  },
  methods: {
    handleCloseModalViewExam() {
      this.isOpenModalViewExam = false
    },
    handleViewExam(item) {
      this.isOpenModalViewExam = true
      this.lessonClassSchoolId = item.id
    },
    handleAssignSuccess() {
      this.handleCloseModalAssignExam();
    },
    handleCloseModalAssignExam() {
      this.isOpenModalAssignExam = false;
    },
    handleAssignExam(item) {
      this.itemExamSelected = item;
      this.isOpenModalAssignExam = true;
    },
    handleChangeSubjectId(e) {
      this.getDataExam();
    },
    handleChangeClassId(e) {
      this.getTypesFilter();
      this.getDataExam();
    },
    handleOnFilter() { },
    getDataExam() {
      let self = this;
      getListBankExamExcercise(this.paramQueryData).then((res) => {
        if (res && res.data && !res.errors) {
          self.listDataExam = res.data.list;
          self.totalRecords = res.data.paging.totalRecords;
        }
      });
    },
    getTypesFilter() {
      let self = this;
      self.listDataSubject = [{ value: 0, text: "Môn học - Tất cả" }];
      this.subjectId = 0;
      getAllTypeFilter({ classId: this.paramQueryData.classId }).then((res) => {
        if (res && res.data && !res.errors) {
          for (let i = 0; i < res.data.ltsSubject.length; i++) {
            const item = res.data.ltsSubject[i];
            self.listDataSubject.push({
              value: item.subjectId,
              text: item.name,
            });
          }
        }
      });
    },
    GetAllClass() {
      let self = this;
      getAllClassFilter({}).then((res) => {
        if (res && res.data && !res.errors) {
          for (let i = 0; i < res.data.length; i++) {
            const item = res.data[i];
            self.listDataClass.push({ value: item.classId, text: item.name });
          }
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.header-title {
  color: #bbbbbb;
}

.data-body {
  padding: 10px;
  border: 1px solid #ebebeb;
  border-radius: 15px;
}

.margin-top-20 {
  margin-top: 20px;
}

.margin-top-10 {
  margin-top: 10px;
}

.icon-search {
  position: absolute;
  top: 0;
  right: 0;
  line-height: 30px;
  padding-right: 20px !important;
}

.justify-content-center {
  justify-content: center;
}
</style>